/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

import { permissionObj } from '../../../../../Helpers/permission';
import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import { EmployeeFlowContractorDetailsApp } from '../../Functionality/ContractorDetailsFlows/EmployeeFlowContractorDetailsApp';
import DivContainerBody from '../../../../../components/DivContainerBody';
import { CommonMainDetailsApp } from '../../Functionality/ContractorDetailsFlows/CommonMainDetailsApp';
import ContractorCardGrid from './ContractorCardGrid';
import CustomExpandableTable from '../../../../../components/table/CustomExpandableTable';
import { getColumns, getSections } from '../../Model/Models';
import {useSelector} from "react-redux";
import {USER_TYPE_MODEL} from "../../../../../enums/userTypeEnum";
import {useMemo} from "react";

const EmployeeFlowContractorDetails = () => {
    const props = CommonMainDetailsApp();
    const {
        dispatch,
        params,
        setElementDetails,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList
    } = props;
    const { t, navigate, DEV, permission, elementDetails } = props;
    const { getContractorById: contractorDetails } = useSelector((state) => state.EmployeeContractorsSlice);
    const { goBack, handleRowExpand } = EmployeeFlowContractorDetailsApp({
        dispatch,
        params,
        setElementDetails,
        setWorkShiftsList,
        setCustomizedList,
    });

    const columns = useMemo(() => getColumns(t), [t]);

    const sections = useMemo(() =>
            getSections({
                userTypeId: USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE,
                contractorId: contractorDetails?.id,
                userId: contractorDetails?.userId,
                workShiftsList,
                customizedList
            }),
        [
            contractorDetails?.id,
            contractorDetails?.userId,
            workShiftsList,
            customizedList
        ]
    );


    if (!DEV && !permission?.includes(permissionObj.WEB_CONTRACTOR_READ))
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={t('details')} onBack={goBack}/>

            <DivContainerBody>
                <div className='row px-0 pb-5'>
                    <div className='col-sm-12 col-md-4 col-lg-3 px-0 mb-sm-3'>
                        <ContractorCardGrid elementDetails={elementDetails} />
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-9 px-0'>
                        {/**Done*/}
                        <CustomExpandableTable
                            columns={columns}
                            rows={sections}
                            checkbox={false}
                            rowsPerPage={sections.length}
                            selectedList={[]}
                            handleCheckboxChange={() => {}}
                            handleDeleteAll={() => {}}
                            renderExpandedRow={({ row }) => row.content()}
                            renderOptionsMenu={null}
                            onRowExpand={handleRowExpand}
                            tooltip={false}
                            showHeader={false}
                            withoutHeight={true}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default EmployeeFlowContractorDetails;
